import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import "./Stay.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import Inner_Stay_Card from "./inner_stay_card/Inner_Stay_Card";

const Stay = ({ data }) => {
  const [activeTab, setActiveTab] = useState("Itinerary");

  const icons = {
    meal: "/assets/images/cruise/itenarary/day-meal.png",
    checkout: "/assets/images/cruise/itenarary/checkout.png",
    car: "/assets/images/cruise/itenarary/private-tranfer.png",
    bed: "/assets/images/cruise/itenarary/bed-img.png",
    map: "/assets/images/cruise/itenarary/activity.png",
    flight: "/assets/images/cruise/itenarary/flight1.png",
  };

  const staticData = [
    {
      img:"https://media3.thrillophilia.com/filestore/fd35milux9qhk5bpr1bv9jcnabjm_120063170.jpg",
      hotelName:"Fosshotel Lind",
      rating:"4.1/5"
    },
    {
      img:"https://media3.thrillophilia.com/filestore/ygnpgciyx5eo86j5xlfljgsfug84_download.png",
      hotelName:"City Center Hotel Reykjavik",
      rating:"4.0/5"
    },
  ]


  return (
    <div className="Itinerary_Tab">
      <>
        <div className="city_header">
          {data?.title} - <span>{data?.duration}</span>
        </div>

        <Accordion defaultActiveKey="0" className="custom_accordion">
          {data?.itineraries?.map((d, index) => (
            <Accordion.Item  eventKey={index.toString()}>
              <Accordion.Header>
                {d?.title}

                <div className="icon_holder">
                  <FontAwesomeIcon
                    icon={faAngleDown}
                    className="inner_icon down_icon"
                  />
                  <FontAwesomeIcon
                    icon={faAngleUp}
                    className="inner_icon up_icon"
                  />
                </div>
              </Accordion.Header>

              <Accordion.Body>
                <Inner_Stay_Card
                  item={d}
                  icons={icons}
                  staticData={staticData}
                />
              </Accordion.Body>
            </Accordion.Item>
          ))}

        
        </Accordion>
      </>
    </div>
  );
};

export default Stay;
